// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileRecordDto
 */
export interface IFileRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IFileRecordDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFileRecordDto
     */
    file_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordDto
     */
    origin_raw_data?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordDto
     */
    json_data?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordDto
     */
    file_record_result_type?: IFileRecordDtoFileRecordResultTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordDto
     */
    current_file_record_step?: IFileRecordDtoCurrentFileRecordStepEnum;
    /**
     * 
     * @type {Date}
     * @memberof IFileRecordDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IFileRecordDto
     */
    processed_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IFileRecordDto
     */
    line_number?: number;
}

/**
* @export
* @enum {string}
*/
export enum IFileRecordDtoFileRecordResultTypeEnum {
    ERROR = 'ERROR',
    CREATED = 'CREATED',
    UPDATED = 'UPDATED',
    NO_CHANGED = 'NO_CHANGED',
    PROCESSING = 'PROCESSING'
}
/**
* @export
* @enum {string}
*/
export enum IFileRecordDtoCurrentFileRecordStepEnum {
    INITIAL = 'INITIAL',
    READY = 'READY',
    PROCESSING = 'PROCESSING',
    COMPLETE = 'COMPLETE'
}


/**
 * Check if a given object implements the IFileRecordDto interface.
 */
export function instanceOfIFileRecordDto(value: object): value is IFileRecordDto {
    return true;
}

export function IFileRecordDtoFromJSON(json: any): IFileRecordDto {
    return IFileRecordDtoFromJSONTyped(json, false);
}

export function IFileRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'file_id': json['file_id'] == null ? undefined : json['file_id'],
        'origin_raw_data': json['origin_raw_data'] == null ? undefined : json['origin_raw_data'],
        'json_data': json['json_data'] == null ? undefined : json['json_data'],
        'file_record_result_type': json['file_record_result_type'] == null ? undefined : json['file_record_result_type'],
        'current_file_record_step': json['current_file_record_step'] == null ? undefined : json['current_file_record_step'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'processed_at': json['processed_at'] == null ? undefined : (new Date(json['processed_at'])),
        'line_number': json['line_number'] == null ? undefined : json['line_number'],
    };
}

export function IFileRecordDtoToJSON(json: any): IFileRecordDto {
    return IFileRecordDtoToJSONTyped(json, false);
}

export function IFileRecordDtoToJSONTyped(value?: IFileRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'file_id': value['file_id'],
        'origin_raw_data': value['origin_raw_data'],
        'json_data': value['json_data'],
        'file_record_result_type': value['file_record_result_type'],
        'current_file_record_step': value['current_file_record_step'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'processed_at': value['processed_at'] == null ? undefined : ((value['processed_at']).toISOString()),
        'line_number': value['line_number'],
    };
}

